export enum MemeberCommunicationPreferenceValue {
    YES = 37,
    NO = 38
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/member-communication-preference-value.enum.ts